// extracted by mini-css-extract-plugin
export default {"content":"Nia5Wb2QyTNcuSsNob0Y","titlesBlock":"AbleuGBRSWBWMS2TuwMA","subtitle":"m0QTulJ4qG0Hj7BLqx5t"};